import { configureRequest, replacePathVariables } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  DenyExternalFlightBookingRequestForAdminErrorResponse,
  DenyExternalFlightBookingRequestForAdminRequest,
  DenyExternalFlightBookingRequestForAdminSuccessResponse
} from './denyExternalFlightBookingRequestForAdmin.types'

export const denyExternalFlightBookingRequestForAdminApi = async (
  request: DenyExternalFlightBookingRequestForAdminRequest
): Promise<DenyExternalFlightBookingRequestForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.admin.denyExternalFlightBookingRequestForAdmin, {
      requestId: request.requestId
    }),
    method: 'POST',
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as DenyExternalFlightBookingRequestForAdminSuccessResponse
  } else {
    throw response as DenyExternalFlightBookingRequestForAdminErrorResponse
  }
}

export default denyExternalFlightBookingRequestForAdminApi
